<!--
 * @Author: 曹捷
 * @Date: 2019-08-19 15:24:34
 * @LastEditors: 曹捷
 * @LastEditTime: 2021-11-08 17:15:12
 * @Description: file content
 -->
<template>
  <a-modal class="obit-modal-default customerDetails" :confirm-loading="confirmLoading" title="部门详情" v-if="open" :maskClosable="false" v-model:visible="open" @cancel="closeDialog" @ok="closeDialog"
    cancelText="取消" okText="确认" :footer="null" width="1080px">
    <a-descriptions title="基础信息" bordered>
      <a-descriptions-item label="上级部门" name="deptId">{{formData.deptId}}</a-descriptions-item>
      <a-descriptions-item label="部门名称" name="deptName">{{formData.deptName}}</a-descriptions-item>
      <a-descriptions-item label="排序" name="orderNum">{{formData.orderNum}}</a-descriptions-item>
      <a-descriptions-item label="负责人" name="leader">{{formData.leader}}</a-descriptions-item>
      <a-descriptions-item label="联系电话" name="phone">{{formData.phone}}</a-descriptions-item>
      <a-descriptions-item label="部门状态" name="status">{{formData.status}}</a-descriptions-item>
    </a-descriptions>
  </a-modal>
</template>
<script>
import { getCurrentInstance, inject, onMounted, reactive, toRefs } from 'vue'
import { util } from 'obit-wui'


export default {
  // inheritAttrs: false,
  props: {
    open: {
      type: Boolean
    },
    dataInfo: {
      type: Object
    },
    parentDeptList: {
      type: Array
    },
  },
  setup (props, context) {
    let http = inject('http')
    let { proxy } = getCurrentInstance()
    let _data = reactive({
      formData: {},
      confirmLoading: false,
    })
    let _methods = {
      closeDialog () {
        util.util.cleanObj(_data.formData)
        context.emit('update:open', false)
      },
    }
    onMounted(() => {
      let data = util.util.cloneObj(props.dataInfo)
      if (data.parentId == '0') {
        data.deptId = data.deptName
      } else {
        data.deptId = props.parentDeptList.find((item) => { return item.deptId == data.parentId }).deptName
      }
      data.status = proxy.$fmt('sys_normal_disable', data.status)
      _data.formData = data
    })
    return {
      ...toRefs(_data),
      ..._methods
    }
  },
}
</script>
<style lang="less">
.customerDetails {
  .ant-modal-body {
    padding: 40px;
  }
}
</style>